// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client-editor/" + ({"200":"wix-i18n-config_intl-pluralrules","404":"TagsFilter","405":"TabsFilter","557":"DropdownFilter","586":"wix-bookings-services-preferences-modal","894":"wix-i18n-config_intl-relativetimeformat"}[chunkId] || chunkId) + ".chunk.min.js";
};